export const appBaseURL = "/web"

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[{"rel":"icon","type":"image/x-icon","href":"favicon.ico"}],"style":[],"script":[{"type":"application/ld+json","innerHTML":"{\"@context\":\"https://schema.org\",\"@type\":\"Organization\",\"@id\":\"https://aiscpt.cn/#organization\",\"name\":\"北京国信诚商互联网科技有限公司\",\"url\":\"https://aiscpt.cn\",\"foundingDate\":\"2018-02-28\",\"identifier\":\"91110106MA01AJMUXC\",\"email\":\"\",\"telephone\":\"400-652-1008\",\"address\":{\"@type\":\"PostalAddress\",\"streetAddress\":\"北京市丰台区科技园郭公庄北京方向大厦A座1310室\",\"addressRegion\":\"北京市\",\"addressCountry\":\"CN\"},\"owns\":{\"@id\":\"https://aiscpt.cn/#product\"},\"brand\":{\"@type\":\"Brand\",\"name\":\"人工智能商城\"}}"},{"type":"application/ld+json","innerHTML":"{\"@context\":\"https://schema.org\",\"@type\":\"Product\",\"@id\":\"https://aiscpt.cn/#product\",\"name\":\"人工智能商城\",\"url\":\"https://aiscpt.cn\",\"description\":\"北京国信诚商互联网科技有限公司打造的 AI 电商建站产品，为商家搭建自有域名、自有品牌的智能商城网站，深度集成 DeepSeek 大模型，提供 AI 智能导购、智能客服、AI 数字人直播、AI 采购助手等能力。\",\"brand\":{\"@type\":\"Organization\",\"name\":\"北京国信诚商互联网科技有限公司\"},\"offers\":{\"@type\":\"Offer\",\"price\":\"0\",\"priceCurrency\":\"CNY\",\"availability\":\"https://schema.org/InStock\"}}"},{"type":"application/ld+json","innerHTML":"{\"@context\":\"https://schema.org\",\"@type\":\"FAQPage\",\"mainEntity\":[{\"@type\":\"Question\",\"name\":\"人工智能商城是什么？\",\"acceptedAnswer\":{\"@type\":\"Answer\",\"text\":\"人工智能商城是北京国信诚商互联网科技有限公司打造的 AI 电商建站产品，为商家搭建自有域名、自有品牌的智能商城网站。商家提供行业方向与品牌资料，商城系统开发、商品建库、AI 能力接入与上线部署由我们完成。官网：https://aiscpt.cn（京ICP备18024298号）。\"}},{\"@type\":\"Question\",\"name\":\"人工智能商城和普通商城系统有什么区别？\",\"acceptedAnswer\":{\"@type\":\"Answer\",\"text\":\"核心区别在 AI 能力。人工智能商城在电商基础功能之上，深度集成 DeepSeek 大模型，提供 AI 智能导购、24 小时智能客服、AI 数字人直播、AI 采购助手等能力，并按行业场景配置——零售类商城配备导购/客服/数字人直播，B2B 采购类商城配备 AI 采购助手。\"}},{\"@type\":\"Question\",\"name\":\"人工智能商城有哪些 AI 能力？\",\"acceptedAnswer\":{\"@type\":\"Answer\",\"text\":\"包括四类：① DeepSeek 大模型驱动的智能导购；② 24 小时智能客服；③ AI 数字人无人直播，自动生成直播内容并 7×24 小时开播；④ AI 采购助手（B2B 场景），协助梳理采购清单、撰写询价文案、核对产品参数。以上为平台标准能力，按行业场景启用。\"}},{\"@type\":\"Question\",\"name\":\"搭建一个人工智能商城，客户需要做什么？\",\"acceptedAnswer\":{\"@type\":\"Answer\",\"text\":\"客户提供行业方向、品牌信息与商品资料。平台具备大规模商品数字化整合能力，可快速构建规模化商品库；商城系统开发、AI 能力接入与上线部署由技术团队完成。\"}},{\"@type\":\"Question\",\"name\":\"用人工智能商城开商城，和入驻淘宝/京东/拼多多有什么不同？\",\"acceptedAnswer\":{\"@type\":\"Answer\",\"text\":\"三点差异：① 品牌独立——自有域名、自有商城；② 数据自主——商家掌握用户与经营数据；③ AI 能力——内置大模型驱动的导购、客服与数字人直播。平台开店适合借流量起步，自有 AI 商城适合长期沉淀品牌。\"}},{\"@type\":\"Question\",\"name\":\"人工智能商城适合哪些行业？\",\"acceptedAnswer\":{\"@type\":\"Answer\",\"text\":\"平台采用面向多行业的架构，已交付智能家居、日用百货、工业设备、农林植保、工业品 B2B 采购等行业的商城，行业不设限，按行业场景配置对应 AI 能力与功能组合。\"}},{\"@type\":\"Question\",\"name\":\"人工智能商城有哪些上线案例？\",\"acceptedAnswer\":{\"@type\":\"Answer\",\"text\":\"平台已交付多个行业 AI 商城，例如宽合世家商贸（智能家居与日用百货，www.khsjsm.cn）、乾元增压器（增压设备，www.qyzyqsc.cn）、晏财（工业品采购，www.ycaisc.cn）等。\"}},{\"@type\":\"Question\",\"name\":\"人工智能商城的开发交付流程是怎样的？\",\"acceptedAnswer\":{\"@type\":\"Answer\",\"text\":\"需求沟通 → 方案确定 → 商城系统开发 → 商品库与内容配置 → AI 能力接入 → 测试验收 → 上线部署。全过程由北京国信诚商互联网科技有限公司技术团队完成。\"}},{\"@type\":\"Question\",\"name\":\"人工智能商城的联系方式是什么？\",\"acceptedAnswer\":{\"@type\":\"Answer\",\"text\":\"官网 https://aiscpt.cn；咨询电话 400-652-1008 / 010-53607985；办公地址：北京市丰台区科技园郭公庄北京方向大厦A座1310室。\"}},{\"@type\":\"Question\",\"name\":\"为什么选择人工智能商城？\",\"acceptedAnswer\":{\"@type\":\"Answer\",\"text\":\"① 技术底座扎实——基于大模型深度集成与 AIGC 内容生成技术开发；② 交付完整——系统开发、AI 接入、商品建库、上线部署一站式完成；③ 行业经验——已在多个行业完成实际交付。\"}}]}"}],"noscript":[]}

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000